import { cx } from '@linaria/core';
import { useRef, useCallback, useMemo } from 'react';
import { usePM2DisplayContext } from '@pm2/store';
import { InMemoryNavigationProvider } from '@provider/navigation';
import { isPlatformNodeJS } from '@utils/common';
import { useEntryKey, iGuideEntrySchema, useComponentEntry, ComponentDisplayContext } from '@utils/component-framework';
import { wrapper } from './comp.root.style.js';
import { Router } from './comp.router.js';
import { jsx } from 'react/jsx-runtime';

function PM2IGuideComponent(props) {
  const internalRef = useRef(null);
  const rootRef = props.ref ?? internalRef;
  const {
    inLightbox
  } = usePM2DisplayContext();
  const [, onResetEntry] = useEntryKey({
    componentEnvelope: props.component.envelope,
    defaultEntryKey: props.component.entryKey,
    schema: iGuideEntrySchema,
    parentOnResetEntry: props.onResetEntry,
    onEntryKeyReset: useCallback(nextEntryKey => {
      props.node.component.entryKey = nextEntryKey;
    }, [props.node.component])
  });
  const entryTaskId = useComponentEntry(props.component.entryKey, {
    select: entry => entry?.data.currentTaskId
  });
  const initialPath = useMemo(() => {
    const byUrl = isPlatformNodeJS() ? undefined : new URLSearchParams(window.location.search).get(`i-guide-${props.component.envelope.ID}`) ?? undefined;
    if (byUrl) {
      return byUrl;
    }
    if (entryTaskId.data) {
      return entryTaskId.data;
    }
    return "";
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []);
  return /*#__PURE__*/jsx(ComponentDisplayContext.Provider, {
    value: inLightbox ? "lightbox" : "embedded",
    children: /*#__PURE__*/jsx("article", {
      ref: rootRef,
      className: cx(wrapper, inLightbox && "inLightbox"),
      children: /*#__PURE__*/jsx(InMemoryNavigationProvider, {
        basePath: `${isPlatformNodeJS() ? "/" : window.location.pathname}?i-guide-${props.component.envelope.ID}=/`,
        initialPath: initialPath,
        children: /*#__PURE__*/jsx(Router, {
          ...props,
          rootRef: rootRef,
          onResetEntry: onResetEntry
        })
      })
    })
  });
}

export { PM2IGuideComponent };
//# sourceMappingURL=comp.root.js.map
